import { ChevronDown } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/photo-1699325635304-a2f409b06d19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxwb3JzY2hlJTIwOTExJTIwZ3QzJTIwcnN8ZW58MHx8fHwxNzc0ODkwNzQzfDA&ixlib=rb-4.1.0&q=85&w=1920";

export default function HeroSection() {
  const scrollToAbout = () => {
    const el = document.querySelector("#about");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative h-screen w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Porsche 911 GT3 RS"
          className="w-full h-full object-cover"
          data-testid="hero-image"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-24 md:pb-32 max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#737373] mb-4 animate-fade-in-up">
          Sammamish, Washington
        </p>
        <h1
          data-testid="hero-heading"
          className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-black uppercase text-white leading-[0.9] animate-fade-in-up animate-delay-100"
        >
          Premium<br />Auto Detailing
        </h1>
        <p className="mt-6 text-base md:text-lg text-[#A3A3A3] max-w-lg leading-relaxed animate-fade-in-up animate-delay-200">
          Obsessive attention to detail. We treat every vehicle as if it were our own — from daily drivers to exotics.
        </p>
        <div className="mt-8 flex gap-4 animate-fade-in-up animate-delay-300">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
            data-testid="hero-cta-button"
            className="btn-primary inline-flex items-center justify-center px-8 py-3 bg-white text-black font-bold text-sm tracking-wider uppercase"
          >
            Book Now
          </a>
          <a
            href="#services"
            onClick={(e) => { e.preventDefault(); document.querySelector("#services")?.scrollIntoView({ behavior: "smooth" }); }}
            data-testid="hero-services-button"
            className="inline-flex items-center justify-center px-8 py-3 border border-[#262626] text-white font-bold text-sm tracking-wider uppercase hover:border-white transition-colors duration-300"
          >
            Our Services
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToAbout}
        data-testid="scroll-down-button"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-[#737373] hover:text-white transition-colors animate-bounce"
      >
        <ChevronDown size={28} />
      </button>
    </section>
  );
}
